import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";

import { Agenda } from "data/interfaces";
import moment from 'moment';

import * as api from "services/firebase";

import * as images from "../../images/images";
import Busca from "./components/busca";
import Detalhe from "./components/detalhe";
import {
  Picture,
  Title,
  SubTitle,
  Container,
  Person,
  Information,
  Endereco,
  Telefone,
  Imagem,
  Back,
} from "./styles";

function Eventos() {
  const primeiro = {} as Agenda;
  const [eventos, setEventos] = useState<Agenda[]>([]);
  const [eventosTmp, setEventosTmp] = useState<Agenda[]>([]);
  const [cadastroSelecionado, setCadastroSelecionado] = useState<Agenda>(
    primeiro
  );
  const { id, share } = useParams();
  const history = useHistory();

  useEffect(() => {
    if (share === "1") {
      const detalheDiv = document.querySelector("#detalhe");
      detalheDiv?.setAttribute("style", "display: block");
      const listaDiv = document.querySelector("#lista");
      listaDiv?.setAttribute("style", "display: none");
    } else {
      const detalheDiv = document.querySelector("#detalhe");
      detalheDiv?.setAttribute("style", "display: none");
      const listaDiv = document.querySelector("#lista");
      listaDiv?.setAttribute("style", "display: block");
    }
  }, [id, share]);

  useEffect(() => {
    api.getAgenda((cadastros: Agenda[]) => {
      setEventos(cadastros);
      setEventosTmp(cadastros);
      if (share) {
        const itemShare: Agenda = cadastros
          .filter((item) => item.key === id)
          .shift() as Agenda;
        if (itemShare) {
          setCadastroSelecionado(itemShare);
        }
      }
    });
  }, [id, share]);

  function handleChange(newValue: Agenda[]) {
    setEventos(newValue);
  }

  function handleSelect(newValue: Agenda) {
    setCadastroSelecionado(newValue);
    history.push("/evento/0/1");
  }

  function handleBack() {
    history.push("/eventos");
  }

  return (
    <>
      <div id="lista" style={{ display: "none" }}>
        <Imagem src={images.imgExc3} alt="foto" />
        <Busca
          cadastros={eventos}
          cadastrosTmp={eventosTmp}
          onChange={handleChange}
        />
        <Container>
          {eventos.map((cadastro) => (
            <Person
              key={cadastro.key}
              onClick={() => {
                handleSelect(cadastro);
              }}
            >
              <Picture src={cadastro.urlImage} alt="Foto" />
              <Information>
                <Title fontSize={16}>{cadastro.tipo.toLowerCase()}</Title>
                <SubTitle>
                  {moment(cadastro.data).format("DD-MM-YYYY")}
                </SubTitle>
                <Telefone>{cadastro.descricao}</Telefone>
                <Endereco>{cadastro.link}</Endereco>
              </Information>
            </Person>
          ))}
        </Container>
      </div>

      <div id="detalhe" style={{ display: "block" }}>
        <Back
          onClick={() => {
            handleBack();
          }}
        />
        <Detalhe cadastro={cadastroSelecionado} />
      </div>
    </>
  );
}

export default Eventos;
